module.exports = __webpack_public_path__ + "static/assets/4024d746516334f6b3e8487046bd3c4f.svg";